export default __webpack_public_path__ + "d44fad87c8c5197c89d0b83236ecef84.gif";